<p-dialog
  header="Email"
  [position]="'center'"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [closable]="!isSending"
  [closeOnEscape]="!isSending"
  styleClass="client-portal-email-dialog"
  [(visible)]="visible"
  (onHide)="closeModal()"
  [style]="{
    width: '976px',
    'max-width': 'calc(100vw - 48px)',
    'max-height': 'calc(100vh - 48px)',
    'border-radius': '8px',
    overflow: 'hidden',
  }">
  <div class="client-portal-email-modal">
    <div class="email-form-card">
      <!-- Subject Field -->
      <div class="form-group mb-3">
        <label class="form-label">Subject</label>
        <input
          pInputText
          type="text"
          class="form-control"
          [(ngModel)]="emailSubject" />
      </div>

      <!-- Current Email Recipients Section -->
      <div class="form-group mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label mb-0">Current Email Recipients</label>
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn-action btn-add"
              [disabled]="isSending || loadingRecipients"
              (click)="addRecipient()">
              <i class="pi pi-plus-circle"></i>
              <span>Add Line</span>
            </button>
            <button
              type="button"
              class="btn-action btn-delete"
              (click)="removeRecipient(selectedRecipientIndex!)"
              [disabled]="isSending || selectedRecipientIndex === null">
              <i class="pi pi-trash"></i>
              <span>Delete</span>
            </button>
          </div>
        </div>
        <div
          class="email-recipients-table p-datatable-customers p-datatable p-component p-datatable-hoverable p-datatable-striped table-listing">
          <div>
            <table class="recipients-table p-datatable-table">
              <thead class="p-datatable-thead">
                <tr class="table-head">
                  <th>Recipient</th>
                  <th>Display Name</th>
                  <th>Recipient Type</th>
                  <th>Add Type</th>
                </tr>
              </thead>
              <tbody class="p-element p-datatable-tbody">
                <tr
                  *ngFor="let recipient of recipients; let i = index"
                  class="p-selectable-row p-datatable-selectable-row ng-star-inserted"
                  [class.selected]="selectedRecipientIndex === i"
                  [class.p-datatable-row-selected]="
                    selectedRecipientIndex === i
                  "
                  (click)="selectRecipient(i)">
                  <td>
                    <span class="link">{{ recipient.email }}</span>
                  </td>
                  <td>
                    <span>{{ recipient.displayName }}</span>
                  </td>
                  <td>
                    <span>{{ recipient.recipientType }}</span>
                  </td>
                  <td>
                    <select
                      class="form-select form-select-sm recipient-addtype-select"
                      [disabled]="isSending"
                      [attr.aria-label]="'Address type for ' + recipient.email"
                      [(ngModel)]="recipient.addType"
                      (click)="$event.stopPropagation()">
                      <option
                        *ngFor="let opt of recipientTypeOptions"
                        [value]="opt">
                        {{ opt }}
                      </option>
                    </select>
                  </td>
                </tr>
                <!-- Project compose only offers recipients returned by active project access. -->
                <tr *ngIf="isAddingNewRecipient" class="new-recipient-row">
                  <td>
                    <p-select
                      [options]="availableRecipients"
                      optionLabel="email"
                      optionValue="email"
                      [filter]="true"
                      filterBy="email,displayName"
                      [loading]="loadingRecipients"
                      [disabled]="isSending || loadingRecipients"
                      ariaLabel="Active project recipient"
                      appendTo="body"
                      [(ngModel)]="newRecipient.email"
                      placeholder="Select active recipient" />
                  </td>
                  <td>
                    <span>From project access</span>
                  </td>
                  <td>
                    <span>Active recipients only</span>
                  </td>
                  <td class="d-flex align-items-center gap-2">
                    <select
                      class="form-select form-select-sm recipient-addtype-select"
                      aria-label="New recipient address type"
                      [disabled]="isSending"
                      [(ngModel)]="newRecipient.addType">
                      <option
                        *ngFor="let opt of recipientTypeOptions"
                        [value]="opt">
                        {{ opt }}
                      </option>
                    </select>
                    <div class="d-flex gap-1 flex-shrink-0">
                      <button
                        type="button"
                        class="btn-row-action btn-confirm"
                        aria-label="Add selected active recipient"
                        [disabled]="
                          isSending || loadingRecipients || !newRecipient.email
                        "
                        (click)="confirmNewRecipient()">
                        <i class="pi pi-check"></i>
                      </button>
                      <button
                        type="button"
                        class="btn-row-action btn-cancel"
                        title="Cancel"
                        aria-label="Cancel recipient selection"
                        [disabled]="isSending"
                        (click)="cancelNewRecipient()">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Rich Text Editor -->
      <div class="form-group mb-3">
        <p-editor [(ngModel)]="bodyText" [style]="{ height: '250px' }">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button class="ql-undo" aria-label="Undo">
                <i class="pi pi-undo"></i>
              </button>
              <button class="ql-redo" aria-label="Redo">
                <i class="pi pi-refresh"></i>
              </button>
            </span>
            <span class="ql-formats">
              <select class="ql-header">
                <option value="1">Heading 1</option>
                <option value="2">Heading 2</option>
                <option value="3">Heading 3</option>
                <option selected>Normal text</option>
              </select>
            </span>
            <span class="ql-formats">
              <select class="ql-align"></select>
            </span>
            <span class="ql-formats">
              <select class="ql-color"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-code-block"></button>
              <button class="ql-blockquote"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-link"></button>
              <button class="ql-image"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-code"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-clean"></button>
            </span>
            <span class="ql-formats">
              <button
                type="button"
                class="ql-chatgpt"
                aria-label="ChatGPT"
                title="Generate with AI"
                (click)="onChatGptClick()">
                <span class="chatgpt-icon"></span>
              </button>
            </span>
          </ng-template>
        </p-editor>
      </div>

      <!-- Attachments Section -->
      <div class="form-group mb-3">
        <label class="form-label">Attachment</label>
        <div
          class="drag-drop-area"
          jniGlobalFileDrop
          (filesDropped)="onFilesDropped($event)">
          <div class="drag-drop-content">
            <i class="pi pi-cloud-upload"></i>
            <span>Drag & Drop Files Here</span>
          </div>
        </div>
        <!-- Attached Files List -->
        <div class="attached-files-list mt-3" *ngIf="attachments.length > 0">
          <div
            class="attached-file-item d-flex align-items-center gap-2 px-2 py-1 mb-2"
            *ngFor="let attachment of attachments; let i = index">
            <div
              class="file-icon d-flex align-items-center justify-content-center">
              <span
                class="attachment-file-icon pdf-icon"
                aria-hidden="true"></span>
            </div>
            <div class="file-info flex-grow-1">
              <span class="file-name">{{ attachment.fileName }}</span>
              <span class="file-size">{{ attachment.fileSize }}</span>
            </div>
            <button
              type="button"
              class="btn-action btn-delete"
              *ngIf="!attachment.isDefault"
              (click)="removeAttachment(i)">
              <i class="pi pi-trash"></i>
            </button>
            <span
              class="default-attachment-tag"
              *ngIf="attachment.isDefault"
              title="This attachment is included by default and cannot be removed">
              Default
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div
      class="client-portal-email-footer d-flex justify-content-end align-items-center gap-2">
      <p-button
        label="Send"
        [disabled]="isSending || loadingRecipients"
        [loading]="isSending"
        (click)="sendEmail()" />
    </div>
  </ng-template>
</p-dialog>

<!-- ChatGPT Assistant Popup -->
<p-dialog
  header="Chat GPT Assistant"
  [position]="'center'"
  appendTo="body"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="displayChatGptModal"
  [style]="{ width: '500px' }">
  <div class="p-fluid p-dir-col mt-2">
    <textarea
      pInputText
      rows="6"
      class="w-100"
      placeholder="Enter a prompt to generate the email body"
      [(ngModel)]="chatGptPrompt"></textarea>
  </div>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        variant="outlined"
        severity="secondary"
        [disabled]="showGptLoader"
        (click)="cancelChatGpt()" />
      <p-button
        label="Ok"
        [disabled]="showGptLoader"
        (click)="submitChatGptPrompt()" />
    </div>
  </ng-template>
</p-dialog>
